import { useCallback } from 'react';

import PropTypes from 'prop-types';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import { useIntl } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';

import { CONTACT_US_URL } from '#client/constants';

export function SubscriptionCancelActions({ onConfirm }) {
  const { formatMessage } = useIntl();

  const trackContactCS = useButtonPressedCallback({
    elementName: 'cancel_trial_contact_cs',
    page: 'subscription_cancel'
  });

  const handleContactCS = useCallback(() => {
    trackContactCS();
    window.location.href = CONTACT_US_URL;
  }, [trackContactCS]);

  return (
    <Stack
      gap={2}
      sx={{
        flexDirection: { xs: 'column', sm: 'row' },
        '& > *': { flex: 1 }
      }}
    >
      <Button variant="outlined" size="large" onClick={handleContactCS}>
        {formatMessage({ id: 'dashboard.subscriptionCancel.actions.contactCS' })}
      </Button>
      <Button
        variant="contained"
        size="large"
        onClick={onConfirm}
      >
        {formatMessage({ id: 'dashboard.subscriptionCancel.reason.continue' })}
      </Button>
    </Stack>
  );
}

SubscriptionCancelActions.propTypes = {
  onConfirm: PropTypes.func.isRequired
};
